import React from 'react';
import classNames from 'classnames';

const Question = ({ questionNumber, scratcherPosition, numberOfQuestions, question }) =>  {

  const questionsClass = classNames({
    'scene__content-left': true,
    'scene--hidden': scratcherPosition !== questionNumber
  });

  return (
    <div className={questionsClass}>
      <h2 className="scene__title"><span>{questionNumber}</span> of <span>{numberOfQuestions}</span></h2>
      <p className="scene__p" dangerouslySetInnerHTML={{__html: question}}></p>
    </div>
  );
}

export default Question;



/** WEBPACK FOOTER **
 ** ./src/components/Scenes/Questions/Question.js
 **/